import { render, staticRenderFns } from "./BillServices.vue?vue&type=template&id=5d65fd26&scoped=true"
import script from "./BillServices.vue?vue&type=script&lang=js"
export * from "./BillServices.vue?vue&type=script&lang=js"
import style0 from "./BillServices.vue?vue&type=style&index=0&id=5d65fd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65fd26",
  null
  
)

export default component.exports